'use strict';

angular.module('formApp').controller('fdCustomButtonsCtrl', [
  '$scope',
  'formHandler',
  function ($scope, formHandler) {
    $scope.editCustomButtons = function () {
      formHandler.initializeCustomButtons($scope);
      $scope.models.editing = {
        element: $scope.models.form.customButtons
      };
    };
  }
]);
